export default "__VITE_ASSET__XZ2JhMWT__"